// Platform-keyed sign-in method selection for the shared auth form, extracted as pure logic so
// the platform matrix is unit-testable (the page itself is not jest-mountable). The caller passes
// a `native` boolean: this web build always passes false; a native build passes its own runtime
// platform check.

export type AuthMode = 'magic' | 'password';

/**
 * The method the login form defaults to.
 * - Web → `magic`: the email magic-link is the primary, password-free web flow.
 * - Native (app-store builds) → `password`: the stores require a username+password path, and a
 *   magic link has no inbound-email/deep-link return on native.
 */
export const initialAuthMode = (native: boolean): AuthMode => (native ? 'password' : 'magic');

/**
 * Toggle button order: the platform's default (pre-selected) mode is listed FIRST, so the active
 * pill lands first. Web → `['magic', 'password']`; native → `['password', 'magic']`.
 */
export const authModeOrder = (native: boolean): AuthMode[] =>
  native ? ['password', 'magic'] : ['magic', 'password'];
